import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
import PButton from 'primevue/button';
import { ref, watch } from 'vue';
import CloseIcon from '../assets/icons/close.svg';
import SearchIcon from '../assets/icons/search.svg';
import { vTooltipAccessible } from '../utils/tooltip-directive';
import NamedIcon from './named-icon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'header-search',
    props: {
        term: {
            type: String,
            default: ''
        },
        expanded: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:term'],
    setup(__props) {
        const props = __props;
        const isExpanded = ref(props.expanded);
        const searchTerm = ref(props.term);
        const searchInput = ref(null);
        const focusInput = () => {
            searchInput.value?.focus();
        };
        const onClear = () => {
            searchTerm.value = '';
            focusInput();
        };
        watch(() => props.expanded, (value) => {
            isExpanded.value = value;
        });
        watch(() => props.term, (value) => {
            searchTerm.value = value;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["header-search", { 'is-expanded': isExpanded.value }])
            }, [
                _createElementVNode("form", {
                    method: "get",
                    action: "//search.curtin.edu.au/s/search.html",
                    role: "search",
                    onFocusin: _cache[2] || (_cache[2] = ($event) => (isExpanded.value = true)),
                    onFocusout: _cache[3] || (_cache[3] = ($event) => (searchTerm.value.length === 0 && (isExpanded.value = false)))
                }, [
                    _createElementVNode("div", {
                        class: "search-field",
                        onClick: focusInput
                    }, [
                        _createVNode(NamedIcon, {
                            name: _unref(SearchIcon).id,
                            class: "search-icon"
                        }, null, 8, ["name"]),
                        _withDirectives(_createElementVNode("input", {
                            ref_key: "searchInput",
                            ref: searchInput,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchTerm).value = $event)),
                            type: "search",
                            name: "query",
                            accesskey: "q",
                            "aria-label": "Search Curtin University",
                            placeholder: "Search Curtin University...",
                            class: "search-input",
                            onInput: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('update:term', $event.target.value)))
                        }, null, 544), [
                            [_vModelText, searchTerm.value]
                        ]),
                        _cache[5] || (_cache[5] = _createElementVNode("input", {
                            type: "hidden",
                            name: "collection",
                            value: "curtin-university"
                        }, null, -1)),
                        _cache[6] || (_cache[6] = _createElementVNode("input", {
                            type: "hidden",
                            name: "clive",
                            value: "curtin-web,curtin-staff,curtin-jobs,curtin-maps,curtin-entities"
                        }, null, -1)),
                        _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                            variant: "text",
                            severity: "tertiary",
                            rounded: "",
                            class: _normalizeClass(["search-clear", { 'invisible': searchTerm.value.length === 0 }]),
                            "aria-label": "Clear",
                            onClick: _withModifiers(onClear, ["stop"])
                        }, {
                            default: _withCtx(() => [
                                _createVNode(NamedIcon, {
                                    name: _unref(CloseIcon).id,
                                    class: "close-icon"
                                }, null, 8, ["name"])
                            ]),
                            _: 1
                        }, 8, ["class"])), [
                            [
                                _unref(vTooltipAccessible),
                                { value: 'Clear', autoHide: false },
                                void 0,
                                {
                                    focus: true,
                                    bottom: true
                                }
                            ]
                        ]),
                        _createVNode(_unref(PButton), {
                            type: "submit",
                            severity: "primary",
                            rounded: "",
                            class: _normalizeClass(["search-button", { 'is-hidden': !isExpanded.value && searchTerm.value.length === 0 }])
                        }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createTextVNode(" Search ", -1)
                            ])),
                            _: 1,
                            __: [4]
                        }, 8, ["class"])
                    ])
                ], 32)
            ], 2));
        };
    }
});
